import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ArrowRightLeft, Loader2 } from "lucide-react";

const GESTAO = ["SUPERADMIN", "DIRECAO", "COORDENACAO"];

export const TransferClassButton = ({ student, onDone }) => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [classes, setClasses] = useState([]);
  const [target, setTarget] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setTarget("");
    api.get("/classes", { params: { school_id: student.school_id } })
      .then((r) => setClasses(r.data.filter((c) => c.id !== student.class_id)))
      .catch(() => setClasses([]));
  }, [open, student.school_id, student.class_id]);
  if (!GESTAO.includes(user?.role)) return null;
  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/students/${student.id}/transfer`, { class_id: target });
      toast.success(`Estudante transferido — ${data.message}`);
      setOpen(false);
      onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid="transfer-class-btn">
        <ArrowRightLeft className="mr-1.5 h-4 w-4" />Transferir de turma
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="transfer-class-dialog">
          <DialogHeader><DialogTitle>Transferir {student.full_name}</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500">Turma atual: <b data-testid="transfer-current-class">{student.class_name || "sem turma"}</b></p>
          <Select value={target} onValueChange={setTarget}>
            <SelectTrigger data-testid="transfer-class-select"><SelectValue placeholder="Escolha a nova turma" /></SelectTrigger>
            <SelectContent>
              {classes.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`transfer-option-${c.id}`}>{c.name}{c.shift ? ` · ${c.shift}` : ""}</SelectItem>)}
            </SelectContent>
          </Select>
          <p className="text-xs text-slate-400">As notas e frequências já lançadas continuam registradas na turma anterior.</p>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)} data-testid="transfer-cancel">Cancelar</Button>
            <Button onClick={confirm} disabled={!target || busy} className="bg-blue-700 hover:bg-blue-800" data-testid="transfer-confirm">
              {busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}Confirmar transferência
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
